module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0040.jpg?v=1c96bcf0";